/**
 * Gates the pro-licensing/grace-window layer of managing restrictions (Part 9): the grace-period
 * read + every surface it feeds, and the PRO chip/upgrade prompt on the actions menu. Separate
 * from `admin_managing_restrictions` (the modal itself) so this half can ship dark.
 */
export const CONTENT_RESTRICTIONS_PHASE_3_FLAG = 'content_restrictions_phase_3';

/** Backend lock type for an assessment guide level (matches the `ContentLock` source types). */
export const GUIDE_LEVEL_LOCK_TYPE = 'guide_level';

/** Toggle tooltip when the school's pro state forbids adjusting restrictions (Figma 3388-50241). */
export const NON_PRO_TOGGLE_TOOLTIP = 'Cannot adjust restrictions for school without PRO upgrade.';

/** Warning line on a grace-window school's row and in the header note's breakdown tooltip. */
export const restrictionRemovalMessage = (formattedDate: string): string =>
  `Restrictions will be removed ${formattedDate}`;
